import { useMemo } from 'react';
import { legacy_guard_controls_state } from 'console/shared/content/device/guard-control/legacy/utils';
import { legacy_boiler_heating_circuits_state, legacy_heating_circuits_state, } from 'console/shared/content/device/heating-circuits/legacy/utils';
import { legacy_heating_mode_state } from 'console/shared/content/device/heating-modes/legacy/utils';
import { vehicle_rf_indicators_state } from 'console/shared/content/device/rf-indicators/vehicle/utils';
import { useSelectDevice } from '../index';
import { useLegacyOpenThermState } from './open-therm';
export const useLegacyDeviceState = (initial_state) => {
    const device_state = useMemo(() => {
        if (initial_state) {
            return initial_state;
        }
        return {};
    }, [initial_state]);
    return device_state;
};
export const useLegacyHeatingCircuitState = () => {
    const initial_state = useSelectDevice(legacy_heating_circuits_state);
    const device_state = useLegacyDeviceState(initial_state);
    return device_state;
};
export const useLegacyHeatingModeState = () => {
    const initial_state = useSelectDevice(legacy_heating_mode_state);
    const device_state = useLegacyDeviceState(initial_state);
    return device_state;
};
export const useLegacyBoilerHeatingCircuitState = (id) => {
    const initial_state = useSelectDevice(legacy_boiler_heating_circuits_state);
    const device_state = useLegacyDeviceState(initial_state);
    const open_therm_state = useLegacyOpenThermState(id, device_state);
    return { open_therm_state, ...device_state };
};
export const useLegacyGuardControlState = () => {
    const initial_state = useSelectDevice(legacy_guard_controls_state);
    const device_state = useLegacyDeviceState(initial_state);
    return device_state;
};
export const useVehicleRfIndicatorState = () => {
    const initial_state = useSelectDevice(vehicle_rf_indicators_state);
    const device_state = useLegacyDeviceState(initial_state);
    return device_state;
};
